















import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/volvo-goal-settings/GoalSettingColumns';
import {
  columnGoalSetting,
  EconomicGroup,
  IEconomicGroupGoalsDetails,
  inputColumnGoalSetting,
  inputManualColumnGoalSetting,
  numberColumnGoalSetting,
  percentColumnGoalSetting,
  percentIndustryColumnGoalSetting,
  labelColumnGoalSetting,
  Family,
} from '@/modules/business-plan/modules/approval/pages/volvo-goal-settings/types';
import {NumberHelper} from '@/utils/number.helper';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';

@Component({
  name: 'TableFooterGoalSettingComponent'
})
export default class TableFooterGoalSettingComponent extends Vue {
  public numeral = numeral;

  @Prop({required: true})
  public columns: GoalSettingColumns;

  @Prop({required: true})
  public economicGroup: EconomicGroup;

  public getDistinctValues(selector: (obj: IEconomicGroupGoalsDetails) => number, column: any, isSales = false, families: any = []): Array<number> {
    const filterNotViewOnly = (x: IEconomicGroupGoalsDetails) => !column.onlyView(x.idFamily);

    if (isSales) {
      return  this.sales.filter(filterNotViewOnly).map(selector)
    }

    if (families && families.length) {
      return _.uniqWith(this.sales.filter(filterNotViewOnly), (arrVal, othVal) => {
        return arrVal.nameSegment === othVal.nameSegment && arrVal.idSaleType === othVal.idSaleType && families.includes(othVal.idFamily);
      }).map(selector);
    }

    return _.uniqWith(this.sales.filter(filterNotViewOnly), (arrVal, othVal) => {
      return arrVal.nameSegment === othVal.nameSegment && arrVal.idSaleType === othVal.idSaleType;
    }).map(selector);
  }

  public getDistinctFamilies(col: numberColumnGoalSetting): Array<number> {
    const families = (col as numberColumnGoalSetting).distinctByFamilies;
    return this.sales
      .filter(x => !families.includes(x.idFamily) && !col.onlyView(x.idFamily))
      .map((col as numberColumnGoalSetting).getterValue);
  }

  public getFormat(col: columnGoalSetting): string {
    const dict = [
      {typeElement: 'number', format: '0,0'},
      {typeElement: 'percent', format: '0.0%'},
    ];
    const {format} = dict.find(x => x.typeElement === col.typeElement) || dict[0];
    return format;
  }

  public getValue(col: columnGoalSetting): string | number {
    let result: number;
    const filterNotViewOnly = (x: IEconomicGroupGoalsDetails) => !col.onlyView(x.idFamily)
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    if ((col as numberColumnGoalSetting).getterValue) {
      if ((col as numberColumnGoalSetting).distinctValues && (col as numberColumnGoalSetting).distinctByFamilies.length) {
        return Array.from(this.getDistinctFamilies(col as numberColumnGoalSetting)).sum();
      }

      if ((col as numberColumnGoalSetting).distinctValues) {
        return Array.from(this.getDistinctValues((col as numberColumnGoalSetting).getterValue, col)).sum();
      }

      return this.sales.filter(filterNotViewOnly).sumBy((col as numberColumnGoalSetting).getterValue);
    }

    if ((col as percentIndustryColumnGoalSetting).getterOver && !(col as percentIndustryColumnGoalSetting).withSubtract) {
      let value = col as percentIndustryColumnGoalSetting;
      const total = Array.from(this.getDistinctValues(value.getterIndustryTotal, value, false, value.distinctByFamilies)).sum();
      const over = Array.from(this.getDistinctValues(value.getterOver, value, true)).sum();

      result = over / total;
      return result;
    }

    if ((col as percentColumnGoalSetting).getterOver) {
      const value = col as percentColumnGoalSetting;

      if (value.withSubtract) {
        const sumIndustryNextYear = Array.from(this.getDistinctValues(value.getterTotal, value, false, value.distinctByFamilies)).sum();
        const sumIndustryLastYear = Array.from(this.getDistinctValues(value.getterOver, value, false, value.distinctByFamilies)).sum();

        if (sumIndustryLastYear === 0) {
          return numeral(0).format('0.0%');
        }

        const total = (sumIndustryNextYear / sumIndustryLastYear) - 1;

        return numeral(total).format('0.0%');
      }

      if (value.getterOver) {
        const total = Array.from(this.getDistinctValues(value.getterTotal, value)).sum();
        const over = this.sales.filter(x => !col.onlyView(x.idFamily)).sumBy(value.getterOver);

        result = over / total;

        return result;
      }
    }

    return '';
  }

  public getShareInput(col: inputColumnGoalSetting): string {
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    const total = this.getDistinctValues(this.columns.getInputShareTotalProp, col, false, col.distinctByFamilies).sum();
    const over = this.sales.filter(x => !col.onlyView(x.idFamily)).sumBy(col.getterValue);

    return NumberHelper.percent(total, over);
  }

  public get sales(): IEconomicGroupGoalsDetails[] {
    const saleType = this.columns.saleType.value;
    return this.economicGroup.details.filter(x => saleType === x.idSaleType || saleType === SaleTypeEnum.AllOfIt);
  }
}
